export enum AcceptedFileTypes {
    Image = "Image",
    Video = "Video",
    Audio = "Audio",
    CSV = "CSV",
    EML = "EML",
    PPTX = "PPTX",
    JSON = "JSON"
}


//region limits in MB

const rawRecordingMaxUploadSizeMB = 100;

const audioMaxUploadSizeMB = 25;

const imageMaxUploadSizeMbOld = 10;
const imageMaxUploadSizeMB = 40;

const videoMaxUploadSizeMbOld = 100;
const videoMaxUploadSizeMB = 250;

const customAvatarInputMaxUploadSizeMB = 500;

const csvMaxUploadSizeMB = 100;

const emlMaxUploadSizeMB = 25;

const pptxMaxUploadSizeMB = 25;

const jsonMaxUploadSizeMB = 25;

//endregion limits in MB

//region limits in bytes

const MEGA = 1024 * 1024;

const rawRecordingMaxUploadSize = rawRecordingMaxUploadSizeMB * MEGA;

const audioMaxUploadSize = audioMaxUploadSizeMB * MEGA;

const imageMaxUploadSizeOld = imageMaxUploadSizeMbOld * MEGA;
const imageMaxUploadSize = imageMaxUploadSizeMB * MEGA;

const videoMaxUploadSizeOld = videoMaxUploadSizeMbOld * MEGA;
const videoMaxUploadSize = videoMaxUploadSizeMB * MEGA;

const customAvatarInputMaxUploadSize = customAvatarInputMaxUploadSizeMB * MEGA;

export const csvMaxUploadSize = csvMaxUploadSizeMB * MEGA;

//endregion limits in bytes

//region errors

const rawRecordingSizeExceededMsg = `Recording size limit exceeded. You may upload recording files up to ${rawRecordingMaxUploadSizeMB}MB`;

export const audioSizeExceededMsg = `Audio size limit exceeded. You may upload audio files up to ${audioMaxUploadSizeMB}MB`;

export const imageSizeExceededMsgOld = `Image size limit exceeded. You may upload image files up to ${imageMaxUploadSizeMbOld}MB`;
export const imageSizeExceededMsg = `Image size limit exceeded. You may upload image files up to ${imageMaxUploadSizeMB}MB`;

export const videoSizeExceededMsgOld = `Video size limit exceeded. You may upload video files up to ${videoMaxUploadSizeMbOld}MB`;
export const videoSizeExceededMsg = `Video size limit exceeded. You may upload video files up to ${videoMaxUploadSizeMB}MB`;

//endregion errors

//region utils

export const getMaxUploadFileSize = (useNewLimits: boolean): number => {
    if (useNewLimits) {
        return Math.max(
            audioMaxUploadSize,
            imageMaxUploadSizeOld,
            imageMaxUploadSize,
            videoMaxUploadSizeOld,
            videoMaxUploadSize,
            rawRecordingMaxUploadSize,
            customAvatarInputMaxUploadSize
        );
    }
    else {
        return Math.max(
            audioMaxUploadSize,
            imageMaxUploadSizeOld,
            videoMaxUploadSizeOld,
            rawRecordingMaxUploadSize,
            customAvatarInputMaxUploadSize
        );
    }
};

export const getImageMaxUploadFileSizeMB = (useNewLimits: boolean): number => {
    return useNewLimits ? imageMaxUploadSizeMB : imageMaxUploadSizeMbOld;
};

export const getVideoMaxUploadFileSizeMB = (useNewLimits: boolean): number => {
    return useNewLimits ? videoMaxUploadSizeMB : videoMaxUploadSizeMbOld;
};

export const getMaxUploadFileSizeMbByType = (type: AcceptedFileTypes, useNewLimits?: boolean): number => {
    switch (type) {
        case AcceptedFileTypes.Image:
            return getImageMaxUploadFileSizeMB(useNewLimits);
        case AcceptedFileTypes.Video:
            return getVideoMaxUploadFileSizeMB(useNewLimits);
        case AcceptedFileTypes.Audio:
            return audioMaxUploadSizeMB;
        case AcceptedFileTypes.CSV:
            return csvMaxUploadSizeMB;
        case AcceptedFileTypes.EML:
            return emlMaxUploadSizeMB;
        case AcceptedFileTypes.PPTX:
            return pptxMaxUploadSizeMB;
        case AcceptedFileTypes.JSON:
            return jsonMaxUploadSizeMB;
        default:
            throw new Error("Unsupported file type");
    }
};

export const validateAssetFileSize = (fileSize: number, fileType: string, useNewLimits: boolean): void => {
    if (fileType === "audio/wav" && fileSize > rawRecordingMaxUploadSize) {
        throw Error(rawRecordingSizeExceededMsg);
    }
    if (fileType.startsWith("image") && fileSize > (useNewLimits ? imageMaxUploadSize : imageMaxUploadSizeOld)) {
        throw Error(useNewLimits ? imageSizeExceededMsg : imageSizeExceededMsgOld);
    }
    if (fileType.startsWith("video") && fileSize > (useNewLimits ? videoMaxUploadSize : videoMaxUploadSizeOld)) {
        throw Error(useNewLimits ? videoSizeExceededMsg : videoSizeExceededMsgOld);
    }
    if (fileType.startsWith("audio") && fileSize > audioMaxUploadSize) {
        throw Error(audioSizeExceededMsg);
    }
};

export const validateAssetFileSizeNoThrow = (fileSize: number, fileType: string, useNewLimits: boolean): boolean => {
    try {
        validateAssetFileSize(fileSize, fileType, useNewLimits);
        return true;
    }
    catch (ignored) {
        return false;
    }
};

//endregion utils
